import React from 'react';

import { DropdownMenu } from '@rtkwlf/fenrir-react';
import { useNavigate } from 'react-router-dom';

import type { SubMenuItem } from '@packages/components/navigation/navigation.constants';

import { NavigationTrigger } from '../navigation-trigger/navigation-trigger';

interface NavigationDropdownMenuProps {
  name: string;
  rootPath: string;
  items: SubMenuItem[];
}

export const NavigationDropdownMenu: React.FC<NavigationDropdownMenuProps> = ({
  name,
  rootPath,
  items,
}) => {
  const navigate = useNavigate();

  return (
    <DropdownMenu.Root modal={false}>
      <NavigationTrigger to={rootPath} name={name} isDropdownTrigger />

      <DropdownMenu.Content
        align="start"
        style={{
          minWidth: '14rem',
        }}
      >
        <DropdownMenu.Group>
          {items.map((item) => {
            if (item.target === '_blank') {
              return (
                <DropdownMenu.ExternalLinkItem
                  key={item.to}
                  href={item.to}
                  target="_blank"
                  paddingRight="xlarge"
                >
                  <DropdownMenu.ExternalLinkItemText>
                    {item.text}
                  </DropdownMenu.ExternalLinkItemText>
                </DropdownMenu.ExternalLinkItem>
              );
            }

            return (
              <DropdownMenu.Item
                key={item.to}
                onSelect={() => navigate(item.to)}
              >
                <DropdownMenu.ItemText>{item.text}</DropdownMenu.ItemText>
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Group>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
